import { FC, SyntheticEvent, useCallback, useEffect, useState } from 'react'
import { Container, ReportContainer, SectionTitle } from './reports-v2.styles'
import ContentWrapper from '../../components/header/ContentWrapper'
import theme from '../../../theme'
import { Box, DialogContent, Tab, Typography } from '@mui/material'
import TabPanel, { a11yProps } from '../cpi-details/components/LibraryDetailsTabPanel'
import PerformanceReport from './sections/performance-report/PerformanceReport'
import SecurityStackReport from './sections/security-stack-report/SecurityStackReport'
import ExecutivePresentation from './sections/executive-presentation/ExecutivePresentation'
import CustomTemplates from './sections/custom-templates/CustomTemplates'
import { ComingSoonContainer, Header } from '../security-stack-map/ssm.styles'
import { IntegrationsTabs, IntegrationsTabsWrapper } from '../settings/integrations/integrations.styles'
import { Chip } from '../../components/nav/sidebar.styles'
import NewSvg from '../../components/svg/NewSvg'
import { useAppDispatch } from '../../../store/hooks'
import { openToast } from 'store/toasts/toastSlice'
import { ToastVariant } from '../../../store/toasts/toastSlice'
import { CpiServiceV3 } from 'services'

const Reports: FC = () => {
  const dispatch = useAppDispatch()
  const [tabValue, setTabValue] = useState(0)
  const [noActiveCpis, setNoActiveCpis] = useState(false)
  const [templatesRefreshKey, setTemplatesRefreshKey] = useState(0)

  const handleTemplateSaved = useCallback(() => {
    setTemplatesRefreshKey((prev) => prev + 1)
  }, [])

  const handleTabChange = (event: SyntheticEvent, newValue: number) => {
    setTabValue(newValue)
  }

  useEffect(() => {
    const init = async () => {
      try {
        const cpis = await CpiServiceV3.getAllCpis()
        const hasConfig = cpis.some((c: any) => c.configuration)

        if (!hasConfig) {
          setNoActiveCpis(true)
        }
      } catch (error) {
        dispatch(
          openToast({
            variant: ToastVariant.error,
            props: {
              text: 'Failed to fetch CPIs',
              description: 'There was an error while fetching CPIs. Please contact our support team.'
            }
          })
        )
      }
    }

    init()
  }, [])

  return (
    <Container>
      <Header className="header">
        <Box className="header-top">
          <Typography className="header-title">Reports</Typography>
        </Box>
        <IntegrationsTabsWrapper sx={{ width: '100%' }}>
          <IntegrationsTabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="ssm-tabs"
            TabIndicatorProps={{
              style: { display: 'none' }
            }}
            isdetails="true"
            sx={{
              '.MuiButtonBase-root': {
                '&.Mui-disabled': {
                  color: `${theme.colors.devicesSecondaryText} !important`
                }
              }
            }}
          >
            <Tab label="Reports" {...a11yProps(0)} />
            <Tab
              label={
                <ComingSoonContainer>
                  <Box className="coming-soon-wrapper">
                    <Chip isNew={false}>
                      <NewSvg />
                      <Typography className="chip-title">Coming Soon</Typography>
                    </Chip>
                  </Box>
                  <Typography className="label-text">Download History</Typography>
                </ComingSoonContainer>
              }
              {...a11yProps(1)}
              disabled
            />
          </IntegrationsTabs>
        </IntegrationsTabsWrapper>
      </Header>
      <ContentWrapper line={1} sx={{ background: theme.colors.pageBackground }}>
        <>
          <DialogContent sx={{ p: 0 }}>
            <TabPanel value={tabValue} index={0} sx={{ padding: '24px 0' }}>
              <SectionTitle>Standard Reports</SectionTitle>
              <ReportContainer>
                <PerformanceReport noActiveCpis={noActiveCpis} onTemplateSaved={handleTemplateSaved} />
                <SecurityStackReport noActiveCpis={noActiveCpis} />
                <ExecutivePresentation noActiveCpis={noActiveCpis} />
              </ReportContainer>
              <Box sx={{ height: '32px' }} />
              <CustomTemplates refreshKey={templatesRefreshKey} />
            </TabPanel>
          </DialogContent>
        </>
      </ContentWrapper>
    </Container>
  )
}

export default Reports
